export const isYoutubeLink = (link?: string) => {
  return !!link?.startsWith('https://www.youtube.com')
}

export const convertToYoutubeEmbed = (link?: string) => {
  if (!link || !isYoutubeLink(link)) {
    return link
  }

  const url = new URL(link)
  const pathname = url.pathname
  const videoId = url.searchParams.get('v')

  if (pathname !== '/watch' || !videoId) {
    return link
  }

  url.pathname = `/embed/${videoId}`
  return url.toString()
}
